import { useState, useEffect } from 'react'
import firebase from '../firebase/compat'
import { client } from './Client'

/**
 * Haalt de bevroren groeisamenvatting arbeidsvaardigheden van de eigen
 * organisatie op via de `getWorkSkillsGrowth` Cloud Function (europe-west1).
 *
 * De kaart las hiervoor de hele `WorkSkillsAssessments`-collectie van de tenant,
 * bij elke keer dat het dashboard openging — één document per deelnemer per
 * kwartaal, zonder datumgrens. Nu is het één document, nachtelijk berekend.
 * Zelfde patroon als `useDataQualityScore`.
 *
 * `computed` onderscheidt drie standen die er op het scherm anders identiek
 * uitzien: de berekening heeft nooit gedraaid (`computed: false`), hij draaide
 * maar er is nog geen tweede beoordeling (`computed: true`, lege `groei`), en er
 * is groei. Zie docs/pitfalls.md#dev-one-off-step-has-no-red-test.
 *
 * AI-CONTEXT: See docs/features/arbeidsvaardigheden.md
 *
 * @returns {{groei: Object<string, {gemiddelde: number, deelnemers: number}>, deelnemers: number,
 *   computed: boolean, computedAt: string|null, loading: boolean, error: Error|null}}
 */
const useWorkSkillsGrowth = () => {
    const [data, setData] = useState(/** @type {object|null} */ (null))
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(/** @type {Error|null} */ (null))

    useEffect(() => {
        let active = true
        setLoading(true)
        setError(null)

        firebase.app().functions('europe-west1')
            .httpsCallable('getWorkSkillsGrowth')({ client })
            .then((result) => { if (active) setData(result.data) })
            .catch((err) => {
                console.error('useWorkSkillsGrowth error:', err)
                if (active) setError(err)
            })
            .finally(() => { if (active) setLoading(false) })

        return () => { active = false }
    }, [])

    return {
        groei: data?.groei || {},
        deelnemers: data?.deelnemers || 0,
        computed: data?.computed === true,
        computedAt: data?.computedAt || null,
        loading,
        error,
    }
}

export default useWorkSkillsGrowth
